module.exports = __webpack_public_path__ + "static/media/pepperchicken-uncropped.22c28a7c.png";